// Setup › General (design spec §9): the company form, its own route and sidebar row since the
// one-page Settings split (features/settings/general.tsx).
import { createRoute } from "@tanstack/react-router";
import { GeneralSettings } from "../features/settings/general";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupGeneralRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "general",
  component: function General() {
    const { api } = setupGeneralRoute.useRouteContext();
    return <GeneralSettings api={api} company={useCompany()} />;
  },
});
